import styled from "styled-components";
import {SIZES} from "@/components/constants";



export const CardWrapInner = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
`

export const CardWrap = styled.div`
    background: #FFFFFF;
    border-radius: 20px;
`;
export const TableWrapper = styled.div`
    margin-top: 30px;
    
`
export const CardWrapTitle = styled.h2`
    font-size: 20px;
    margin-bottom: 15px;
`;
export const SelectDateMap = styled.div`
    display: flex;
    align-items: center;

    .date-select-list {
        width: 80px;
        height: 30px;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 1px solid #eee;
        border-right: none;
        background-color: #fff;

        &:last-child {
            border-right: 1px solid #eee;
        }

        &.active {
            background-color: #333;
            color: #fff;
        }
    }
`
export const SearchSummary = styled.div`
    display: flex;
    align-items: center;
    font-size: 12px;
    gap: 5px;

    .summary {
        span {
            color: #FF463F;
        }
    }
`;
export const TableControlWrap = styled.div`
    display: flex;
    align-items: end;
    justify-content: space-between;
    margin-bottom: 35px;
`

export const TitleContentWrap = styled.div`
    width: 100%;

    &.grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }
    .content{
        min-width: 0;
        overflow: hidden;
    }
`
export const TitleContentAndWrap = styled.div`
    display: flex;
    border-bottom: 1px solid ${({theme}) => theme.COLORS.TABLE.border};
    & > div{
        width: ${(props) => props.$childLength ? `calc(100% / ${props.$childLength})` : "50%"};
        border: none;
        &.float-menu{
            width: 225px;
            .content{
                width: 70px;    
            }
            
        }
    }

    @media (max-width: ${SIZES.TABLET}) {
        display: block;
        & > div{
            width: 100%;
            &:first-child{
                border-bottom: 1px solid #DEDCEC;
            }
        }
    }
    
    
`


export const TitleContentAndWrap02 = styled.div`
    display: flex;
    border-bottom: 1px solid ${({theme}) => theme.COLORS.TABLE.border};
    & > div{
        border: none;
        width: ${(props) => props.$childLength ? `calc(100% / ${props.$childLength})` : "50%"};
        &.float-menu{
            width: 225px;
            .content{
                width: 70px;    
            }
            
        }
        &.form-type{
            .title{
                width: 220px;
                align-items: start;
            }
        }
    }
`

export const TitleContentInner = styled.div`
    display: flex;
    align-content: center;
    min-height: ${(props) => props.$minHeight ? `${props.$minHeight}` : "72px"};
    border-bottom: 1px solid ${({theme}) => theme.COLORS.TABLE.border};
    //&:last-child {
    //    border-bottom: 0;
    //}

    .title {
        vertical-align: middle;
        width: ${(props) => props.$width ? `${props.$width}` : "152px"};
        flex-shrink: 0;
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 24px;
        background: ${({theme}) => theme.COLORS.TABLE.head};

        color: ${({theme}) => theme.COLORS.TABLE.font.head};
        font-weight: ${({theme}) => theme.SIZE.TABLE.THEAD.weight};
        font-size: ${({theme}) => theme.SIZE.TABLE.THEAD.font};
        line-height: 18px;
        text-align: center;

        &.block {
            display: block;
        }
    }

    .content {
        width: 100%;
        padding: 14px 24px;
        display: flex;
        align-items: ${(props) => props.$align ? `${props.$align}` : "center"};
        gap: ${(props) => props.$gap ? `${props.$gap}px` : "20px"};

        &.wrap {
            flex-wrap: wrap;
        }

        .select-type {
            width: 150px;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .title {
            width: 88px;
            padding: 10px 12px;
            flex: 0 0 88px;
        }
        .content {
            padding: 10px 12px;
            flex: 1 1 0; 
            min-width: 0; 
            box-sizing: border-box;
        }
    }
`
export const SearchWrap = styled.div`
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;

`;


export const ButtonWrap = styled.div` // 테이블 하단 버튼 영역
    display: flex;
    align-items: center;
    justify-content: end;
    gap: ${(props) => props.$gap ? `${props.$gap}px` : ""};;

    &.mt {
        margin-top: 35px;
    }

    &.bt {
        margin-bottom: 35px;
    }

    &.pb {
        padding-bottom: 15px;
    }

    &.pt {
        padding-top: 15px;
    }

    &.center {
        justify-content: center;
    }

    &.between {
        justify-content: space-between;
    }

    &.end {
        justify-content: end;
    }

    &.start {
        justify-content: start;
    }

    &.center {
        justify-content: center;
    }

`

export const SaveBtnWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: end;
    margin-bottom: 10px;
`
export const MemoContentArea = styled.div`
    .memo-area {
        display: flex;
        gap: 15px;
        align-items: start;
        width: 100%;
    }

    .content {
        position: relative;
        box-sizing: border-box;
        white-space: pre-line;
        width: 100%;
        height: 100%;
        min-height: 70px;
        text-align: left;
    }


    .memo-inner {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        background: #fff;
        width: 100%;
        height: 100%;

        &.active {
            display: block;
        }
    }

    textarea {
        resize: none;
        outline: none;
        width: 100%;
        height: 100%;
        background: transparent;
        box-sizing: border-box;
    }

    .memo-btn-wrap {
        display: flex;
        flex-direction: column;
        gap: 5px;
        flex-shrink: 0;
    }
`;

export const SearchWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: end;
    .search-content{
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 10px 14px;
        background: #FFFFFF;
        border: 1px solid #D1D1D1;
        border-radius: 8px;
        gap: 8px;
        &.focus{
            border-color: #564F67;
        }
        .react-select__control{
            border: none;
            width: 75px;
            min-width: fit-content;
            padding: 0;
            height: auto;
        }
        .react-select__single-value{
            font-weight: 600;
        }
        .search-area{
            width: 243px;
            position: relative;
            .input-wrapper{
                width: 100%;
                border: none;
                height: 24px;
                padding: 0 24px 0 0;
                input{
                    &::placeholder {
                        font-weight: 400;
                    }
                    font-weight: 800;
                    font-size: 18px;
                }
            }
            .search-btn{
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
            }
            .close-btn{
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        display: block;
        .search-content{
            padding: 10px 14px;
            .select-type{
                flex-shrink: 0;
            }
            .search-area{
                width: 100%;
            }
        }
    }
`






export const SearchWrapper02 = styled.div`
    width: 100%;
    display: flex;
    justify-content: end;
    .search-content{
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 10px 14px;
        background: #FFFFFF;
        border: 1px solid #D1D1D1;
        border-radius: 8px;
        gap: 8px;
        &.focus{
            border-color: #564F67;
        }
        .react-select__control{
            border: none;
            width: 75px;
            min-width: fit-content;
            padding: 0;
            height: auto;
        }
        .react-select__single-value{
            font-weight: 600;
        }
        .search-area{
            width: 243px;
            position: relative;
            .input-wrapper{
                width: 100%;
                border: none;
                height: 24px;
                padding: 0 24px 0 0;
                input{
                    &::placeholder {
                        font-weight: 400;
                    }
                    font-weight: 800;
                    font-size: 18px;
                }
            }
            .search-btn{
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
            }
            .close-btn{
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
`




export const FileWrap = styled.div`
    cursor: pointer;
    width: 18px;
    display: inline-block;
`

export const AllSearchWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    .search-area{
        width: 654px;
        height: 72px;
        border: 2px solid #4939B1;
        box-sizing: border-box;
        border-radius: 99px;
        position: relative;
        .input-wrapper{
            border: none;
            height: auto;
            padding: 24px 40px;
            input{
                padding: 0 40px 0 0;
                color: #4939B1;
            }
        }
        .search-btn{
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 40px;
            cursor: pointer;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 40px 38px 24px;
        .search-area{
            width: 100%;
            height: 48px;
            .input-wrapper{
                height: 100%;
                padding: 0 24px;
                input{
           
                }
            }
            .search-btn{
     
            }
        }
    }
`
export const ListInfoControlWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`
export const FileUploadArea = styled.div`
    width: 100%;
    .file-hide-input{
        width: 0;
        height: 0;
        opacity: 0;
        display: none;
    }
    .file-wrap{
        //cursor: pointer;
        .file-input-wrap{
            cursor: pointer;
            width: 100%;
            position: relative;
            .file-search-btn{
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 14px;
                svg{
                    transform: rotate(-135deg);
                }
            }
        }
    }
    .file-list-info{
        margin-top: 12px;
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        .file-item-wrap{
            padding: 0 20px;
            height: 44px;
            border: 1px solid #CCCCCC;
            border-radius: 99px;
            display: flex;
            align-items: center;
            gap: 10px;
            .file-item-name{
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
                letter-spacing: 0.02em;
                color: #564F67;
                cursor: pointer;
            }
        }
    }
    &.view-img{
        .file-list-info{
            .file-item-wrap{
                height: auto;
                border-radius: 5px;
                width: 70%;
                display: block;
                padding: 16px;
                .cancel-btn{
                    display: flex;
                    justify-content: end;
                    margin-bottom: 10px;
                }
                .file-item-name{
                    
                }
            }
        }
    }

    @media (max-width: ${SIZES.TABLET}) {
        
            width: 100%;
            .file-wrap{
                cursor: pointer;
                .file-input-wrap{
                    .input-wrapper{
                        padding: 0 35px 0 14px;
                        width: 100%;
                        min-width: 0;
                        input{
                            width: 100%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
            }
            .file-list-info{
                display: block;
                overflow: hidden;
                .file-item-wrap{
                    width: 100%;
                    max-width: 100%;
                    min-width: 0;
                    display: flex;
                    align-items: center;
                    & + .file-item-wrap{
                        margin-top: 12px;
                    }
                    .file-item-name{
                        flex: 1 1 auto;        // 남는 폭 다 먹되
                        min-width: 0;          // 줄어들 수 있게
                        max-width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;   // 한 줄 … 처리
                    }
                }
            }
        
    }
`
export const RequiredStar = styled.div`
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.02em;
    color: #246FF2;
    margin-left: 2px;
`;

export const ImportInfo = styled.div`
    color: #246FF2;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.25;
    display: flex;
    align-items: center;
    &.pd{
        padding: 0 10px 10px;
    }
    &.py{
        padding: 0 10px 0;
    }
    &.mg{
        margin-top: 8px;
    }
    &.mb{
        margin-bottom: 8px;
    }
    &.pd-10{
        padding: 10px;
    }
`

export const NoDataList = styled.div`
    padding: 60px 0 60px;
    vertical-align: middle;
    color: #38304D;
    font-weight: 400;
    font-size: 14px;
    border-bottom: 0;
    text-align: center;
    white-space: pre-line;
    line-height: 1.25;
    border-top: 1px solid #DEDCEC;
    &.bd-no{
        border: none;
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 50px 0 50px;
    }
`
export const ImageSource = styled.div`
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: #CDCCDC;
    margin-top: 8px;
    .source-inner{
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .w-460{
        width: 460px;
    }
    &.right{
        text-align: right;
        .source-inner{
            align-items: start;
            justify-content: end;
            span{
                &:last-child{
                    word-break: break-all;
                    text-align: left;
                }
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding-right: 16px;
        .w-460{
            width: auto;
        }
        .source-inner{
            align-items: start;
        }
        &.right{
            text-align: left;
            .source-inner{
                justify-content: start;
            }
        }
    }
`
export const TextAreaWrap = styled.div`
    width: 100%;
    padding: 8px;
    border: 1px solid #D1D1D1;
    overflow: hidden;

    textarea{
        width: 100%;
        box-sizing: border-box;
        outline: none;
        resize: none;
        border: none;
    }
    &.rd{
        border-radius: 8px;
        textarea{
            
        }
    }
`